import isEqual from 'lodash/isEqual';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { initialState as searchInitialState } from 'app/views/layout/views/search/search.reducer';
import { createSearchUrl } from 'app/views/layout/views/search/utils';
import { useAppSelector } from 'utils/redux/useAppSelector';

export const useConversationsUrl = (): string => {
  const { searchParams } = useAppSelector(
    (state) => ({
      searchParams: state.search.params,
    }),
    shallowEqual,
  );

  return useMemo(() => {
    /**
     * The default link to the new Search view should have the "Open" status filter preapplied.
     *
     * @TODO Remove this and handle it in the initial Redux state after GA:
     * https://dixa-product.atlassian.net/browse/INSIGHTS-1154
     */
    return createSearchUrl(
      isEqual(searchParams, searchInitialState.params)
        ? {
            ...searchParams,
            filters: {
              strategy: 'all',
              filters: [
                {
                  field: 'status',
                  operator: 'is_one',
                  values: [{ value: 'open' }],
                },
              ],
            },
          }
        : searchParams,
    );
  }, [searchParams]);
};
